var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('Modal', {
    attrs: {
      "title": "导入结果"
    },
    model: {
      value: _vm.importResultModal,
      callback: function ($$v) {
        _vm.importResultModal = $$v;
      },
      expression: "importResultModal"
    }
  }, [_c('div', {
    staticClass: "import-result-modal"
  }, [_c('h3', [_vm._v(" 成功导入" + _vm._s(_vm.importResultData ? _vm.importResultData.successImportCount : "") + "个，错误信息" + _vm._s(_vm.importResultData ? _vm.importResultData.errorData.length : "") + "个 ")]), _vm._l(_vm.importResultList, function (item) {
    return _c('div', [_vm._v(_vm._s(item))]);
  })], 2)]), _c('Modal', {
    attrs: {
      "title": "设置回款任务"
    },
    on: {
      "on-ok": _vm.autoSetReceiveTaskMethod
    },
    model: {
      value: _vm.setReceiveTaskModal,
      callback: function ($$v) {
        _vm.setReceiveTaskModal = $$v;
      },
      expression: "setReceiveTaskModal"
    }
  }, [_c('p', [_vm._v("你确定要自动设置回款任务吗？")]), _c('p', [_vm._v("自动设置回款任务会将客户账龄最长的月份自动设置为回款任务，如果金额不满10,000则往前顺延")])]), _c('Modal', {
    attrs: {
      "width": "18",
      "title": "手动设置回款任务"
    },
    model: {
      value: _vm.manualSetReceiveTaskModal,
      callback: function ($$v) {
        _vm.manualSetReceiveTaskModal = $$v;
      },
      expression: "manualSetReceiveTaskModal"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "回款任务金额",
      "formatter": function (value) {
        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      "parser": function (value) {
        return value.replace(/\$\s?|(,*)/g, '');
      }
    },
    model: {
      value: _vm.receiveTaskSum,
      callback: function ($$v) {
        _vm.receiveTaskSum = $$v;
      },
      expression: "receiveTaskSum"
    }
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.setReceiveTaskMethod
    }
  }, [_vm._v("确认")])], 1)], 1), _c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('h2', {
    staticStyle: {
      "margin": "0 8px 0 16px"
    }
  }, [_vm._v("月份")]), _c('DatePicker', {
    staticStyle: {
      "width": "100px",
      "margin-right": "8px"
    },
    attrs: {
      "type": "month",
      "placement": "bottom-end",
      "placeholder": "选择月份"
    },
    on: {
      "on-change": _vm.changeDate
    },
    model: {
      value: _vm.yearMonth,
      callback: function ($$v) {
        _vm.yearMonth = $$v;
      },
      expression: "yearMonth"
    }
  }), _c('Input', {
    staticStyle: {
      "width": "230px",
      "margin-right": "8px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "180px",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "筛选业务员",
      "label-in-value": "",
      "multiple": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.choseSalesVisible
    },
    model: {
      value: _vm.salesVisible,
      callback: function ($$v) {
        _vm.salesVisible = $$v;
      },
      expression: "salesVisible"
    }
  }, _vm._l(_vm.salesVisibleMember, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c('Select', {
    staticStyle: {
      "width": "180px",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "筛选部门",
      "label-in-value": "",
      "multiple": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.choseDepartment
    },
    model: {
      value: _vm.department,
      callback: function ($$v) {
        _vm.department = $$v;
      },
      expression: "department"
    }
  }, _vm._l(_vm.departmentList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c('Button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openSetReceiveTaskModal
    }
  }, [_vm._v("自动设置任务")]), _c('i-switch', {
    model: {
      value: _vm.displayARTable,
      callback: function ($$v) {
        _vm.displayARTable = $$v;
      },
      expression: "displayARTable"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])]), _c('div', [_vm._v("账龄表截止上个月底")])], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('div', {
    staticClass: "page-wrap"
  }, [_c('Select', {
    staticStyle: {
      "width": "60px",
      "margin-right": "20px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": _vm.changeLimit
    },
    model: {
      value: _vm.limit,
      callback: function ($$v) {
        _vm.limit = $$v;
      },
      expression: "limit"
    }
  }, _vm._l(_vm.limitList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "min-width": "160px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadImportFileProcess
    }
  })], 1), _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "loading": _vm.exportReceiveTaskTableTableLoading
    },
    on: {
      "click": function ($event) {
        return _vm.exportReceiveTaskTable();
      }
    }
  }, [_vm._v("导出回款任务")]), _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.ImportARTableModal.openModal();
      }
    }
  }, [_vm._v("Excel导入账龄表")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.dynamicColumns,
      "data": _vm.statViewBParsed,
      "height": _vm.tableHeight,
      "loading": _vm.tableLoading,
      "border": ""
    },
    scopedSlots: _vm._u([{
      key: "receiveAmountBefore",
      fn: function (_ref) {
        var row = _ref.row,
          column = _ref.column,
          index = _ref.index;
        return [_c('div', {
          staticStyle: {
            "font-weight": "bold",
            "color": "green"
          }
        }, [_vm._v(_vm._s(row.receiveAmountBefore[column._index - 4]))])];
      }
    }, {
      key: "receiveTask",
      fn: function (_ref2) {
        var row = _ref2.row,
          column = _ref2.column,
          index = _ref2.index;
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "space-between",
            "height": "21px"
          }
        }, [_c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "baseline",
            "gap": "2px",
            "width": "85px"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("已回")]), _c('div', {
          staticStyle: {
            "font-weight": "bold",
            "color": "green",
            "width": "46px"
          }
        }, [_vm._v(_vm._s(row.receivedThisMonth))])]), _c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "baseline",
            "gap": "2px"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("剩余")]), _c('div', {
          staticStyle: {
            "font-weight": "bold",
            "width": "46px"
          }
        }, [_vm._v(_vm._s(row.leftReceiveTask))])])]), row.receiveTaskSum ? _c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "baseline"
          }
        }, [_c('div', {
          staticClass: "custom-progress-bar"
        }, [_c('div', {
          staticClass: "custom-progress-bar-inside",
          style: {
            width: row.taskFinishedPercentage
          }
        })]), _c('div', {
          staticStyle: {
            "width": "36px",
            "font-size": "10px"
          }
        }, [_vm._v(" " + _vm._s(row.taskFinishedPercentage) + " ")])]) : _vm._e()];
      }
    }, {
      key: "arTable",
      fn: function (_ref3) {
        var _row$arTable;
        var row = _ref3.row,
          column = _ref3.column,
          index = _ref3.index;
        return [column._index - _vm.fixedColumnCounts < ((_row$arTable = row.arTable) === null || _row$arTable === void 0 ? void 0 : _row$arTable.length) ? _c('div', {
          staticClass: "arTable-cell",
          class: row.arTable[column._index - _vm.fixedColumnCounts].cellClass,
          on: {
            "click": function ($event) {
              return _vm.updateReceiveTaskMethod(row, column, index);
            }
          }
        }, [_c('div', {
          staticClass: "space-between"
        }, [_c('div', {
          staticClass: "cell-yearmonth"
        }, [_vm._v(" " + _vm._s(row.arTable[column._index - _vm.fixedColumnCounts].yearMonthDisplay) + " ")]), _c('div', {
          staticClass: "cell-diff-month",
          style: {
            color: row.arTable[column._index - _vm.fixedColumnCounts].diffColor
          }
        }, [_vm._v(" " + _vm._s(row.arTable[column._index - _vm.fixedColumnCounts].diffMonth) + " ")])]), _c('div', [_vm._v(" " + _vm._s(row.arTable[column._index - _vm.fixedColumnCounts].arDisplay) + " ")])]) : _c('div', [_vm._v(" - ")])];
      }
    }])
  })], 1), _c('ImportARTableModal', {
    ref: "ImportARTableModal",
    on: {
      "importResult": _vm.openImportResultModal
    }
  }), _c('ARDetailDrawer', {
    ref: "ARDetailDrawer"
  }), _c('CustomerCommentDrawer', {
    ref: "CustomerCommentDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }